import * as React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Divider, Button, Avatar, Grid} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CardData from './CardData';
import ModalView from '../../../../modal/ModalView';

import { useSelector, useDispatch } from 'react-redux';
import {setShowDialogue} from '../../../../store/slice/ConfSlice';

export default function CardLayout({card, payload}) {

  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState(false);
  const [mode, setMode] = React.useState(false);
  const [dialogComp, setDialogComp] = React.useState();
  const [title, setTitle] = React.useState('');


  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleAssignation = () =>{
    setMode(!mode);
  }
  const setDialogeActionParams = (id, comp, title) => {
    dispatch(setShowDialogue(true));
    setMode(!mode);
    setDialogComp(comp);
    setTitle(title);
    

  }
  React.useEffect(()=>{
  },[mode])

  return (
    <div>
      <Accordion expanded={expanded === 'panel'} onChange={handleChange('panel')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <CardData fieldList={card.headingList}/>
        </AccordionSummary>
        {card.dataList.length>0?
        <AccordionDetails>
          <CardData fieldList={card.dataList} />
        </AccordionDetails>:<></>}
          
          <Grid container direction="row" justifyContent='flex-end' spacing={.5} padding={.5}>
              {
              payload.actionList.map((action, i) =>{
                return (
                  <Grid key={i} item onClick={()=>{action.callBackMethod(card.id)}}>
                  <Avatar
                      sx={{
                        color: 'primary.main',
                        bgcolor: 'primary.lighter',
                        cursor:'pointer'
                      }}
                    >
                      {action.icon}
                      
                   </Avatar>
                </Grid>
                )
              })}

{
              payload.dialogueActionList.map((dialogaction, i) =>{
                return (
                  <Grid key={i} item onClick={()=>{setDialogeActionParams(card.id, dialogaction.comp, dialogaction.title)}}>
                  <Avatar
                      sx={{
                        color: 'primary.main',
                        bgcolor: 'primary.lighter',
                        cursor:'pointer'
                      }}
                    >
                      {dialogaction.icon}
                      
                   </Avatar>
                </Grid>
                )
              })}

          </Grid>  
      </Accordion>

       { mode?<ModalView setMode={setMode} dialogComp={dialogComp} title={title} id={card.id} />:<></>} 
      
    </div>
  );
}